// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.componentRow {
  display: flex;
  width: 100%;
  height: 150px;
}

.componentRow > div {
  width: 50%;
}`, "",{"version":3,"sources":["webpack://./src/examples/xy-components/crosshair/stacked-vs-non-stacked/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".componentRow {\n  display: flex;\n  width: 100%;\n  height: 150px;\n}\n\n.componentRow > div {\n  width: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"componentRow": `componentRow`
};
export default ___CSS_LOADER_EXPORT___;
